import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PortfolioReportingOverviewTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

const ADD_ITEM_PATHS: Partial<
	Record<PortfolioReportingOverviewTypeEnum, () => string>
> = {
	[PortfolioReportingOverviewTypeEnum.Investment]:
		Routing.Portfolio.PortfolioAddInvestment.path,
	[PortfolioReportingOverviewTypeEnum.InvestmentProperty]:
		Routing.Portfolio.PortfolioAddRealEstate.path,
	[PortfolioReportingOverviewTypeEnum.Cash]:
		Routing.Portfolio.PortfolioAddBankProduct.path,
};

export const useNavigateDashboardAddItem = (
	overviewType: PortfolioReportingOverviewTypeEnum,
) => {
	const navigate = useNavigate();

	return useCallback(() => {
		const getPath =
			ADD_ITEM_PATHS[overviewType] ?? Routing.Portfolio.PortfolioAddItem.path;
		navigate(getPath());
	}, [navigate, overviewType]);
};
